/* eslint-disable react/no-unknown-property */
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { Show } from '@components';

import { CtaFormContainer, CtaHiddenInput } from './styles';

interface IBookingFormProps {
  title?: string;
  content?: string;
  hasBackdrop?: boolean;
}

const BookingForm = ({
  title = 'Book your 100% free, no-obligation expert case review here',
  hasBackdrop = false,
  content,
}: IBookingFormProps) => {
  return (
    <CtaFormContainer hasBackdrop={hasBackdrop} className="cta_form">
      <Show when={hasBackdrop}>
        <div className="cta_form__image">
          <div className="cta_form__image__gradient"></div>
          <StaticImage
            src="../../images/brisbane-local-marketing-a.jpg"
            alt="background"
            className="cta_form__image__wrapper"
          />
        </div>
      </Show>
      <form
        name="new-contact-us-form"
        className="cta_form__form"
        method="POST"
        action="/thank-you"
        data-netlify="true"
        netlify-honeypot="address"
      >
        <input type="hidden" name="form-name" value="new-contact-us-form" />

        <h2 className="cta_form__title">{title}</h2>
        {content && <p className="cta_form__content">{content}</p>}
        <div className="cta_form__row">
          <input
            className="cta_form__input cta_form__input--text"
            type="text"
            placeholder="First Name"
            name="firstName"
            minLength={1}
            required
          />
          <input
            className="cta_form__input cta_form__input--text"
            type="text"
            name="lastName"
            placeholder="Last Name"
            minLength={1}
            required
          />
        </div>
        <div className="cta_form__row">
          <input
            className="cta_form__input cta_form__input--email"
            type="email"
            name="email"
            placeholder="Email"
            minLength={3}
            required
          />
          <input
            className="cta_form__input cta_form__input--tel"
            type="tel"
            name="phone"
            placeholder="Phone"
            minLength={8}
            required
          />
          <CtaHiddenInput
            type="text"
            placeholder="Your home address"
            name="address"
          />
        </div>
        <div className="cta_form__row">
          <button
            className="cta_form__button cta_form__button--submit"
            type="submit"
          >
            Get in Touch
          </button>
        </div>
      </form>
    </CtaFormContainer>
  );
};

export { BookingForm, IBookingFormProps };
